import { combineReducers } from 'redux'
import { activeComponentReducer, activeComponentReducerState } from './activeComponent'
import { autoStringReducer, AutoStringReducerState } from './autoString'
import { detectImageryReducer, DetectImageryState } from './detectImagery'
import { lastCommandTimestampReducer, LastCommandTimestampReducerState } from './lastCommandTimetamp'
import { systemCalculationsQueuedReducer, SystemCalculationsQueuedState } from './systemCalculation'
import { systemsReducer, SystemsReducerState } from './systems'
import {
  tariffRecommendationReducer,
  TariffRecommendationReducerState,
} from './tariffRecommendation'
import { DesignViewReducerState, viewReducer } from './view'

export interface DesignerState {
  systemCalculation: SystemCalculationsQueuedState
  detectImagery: DetectImageryState
  activeComponent: activeComponentReducerState
  systems: SystemsReducerState
  autoString: AutoStringReducerState
  view: DesignViewReducerState
  lastCommandTimestamp: LastCommandTimestampReducerState
  tariffRecommendation: TariffRecommendationReducerState
}

export default combineReducers({
  systemCalculation: systemCalculationsQueuedReducer,
  detectImagery: detectImageryReducer,
  activeComponent: activeComponentReducer,
  systems: systemsReducer,
  autoString: autoStringReducer,
  view: viewReducer,
  lastCommandTimestamp: lastCommandTimestampReducer,
  tariffRecommendation: tariffRecommendationReducer,
})
